/** @jsxImportSource @emotion/react */
import { Fragment } from "react";
import { Card } from "primereact/card";
import { formatMonto } from "../../../../shared";

// Totales de pago pendiente al colaborador, agrupados por moneda. Misma estética
// que CardTotalesPendientes de facturación, sin el desglose de IVA (no aplica a
// los pagos a colaboradores). Recibe las filas de actividades ya mapeadas del
// componente Auditor (con pagoMonto/pagoMoneda/pagoEstado).
export default function CardPagosPendientes({ actividades }) {
  const conPago = (actividades || []).filter((a) => a.pagoMonto != null);
  if (conPago.length === 0) return null;

  const pendientes = conPago.filter((a) => a.pagoEstado !== "pagado");

  if (pendientes.length === 0) {
    return (
      <Card
        css={{
          marginTop: "1em",
          backgroundColor: "var(--green-50)",
          border: "1px solid var(--green-200)"
        }}
      >
        <div css={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <i
            className="pi pi-check-circle"
            css={{ fontSize: "1.5rem", color: "var(--green-600)" }}
          />
          <div css={{ fontWeight: "bold", color: "var(--green-700)" }}>
            No hay pagos pendientes
          </div>
        </div>
      </Card>
    );
  }

  const totalesPorMoneda = new Map();
  let orden = 0;
  for (const a of pendientes) {
    const simbolo = a.pagoMoneda || "";
    const key = a.pagoMonedaId ?? a.pagoMonedaNombre ?? simbolo;
    if (!totalesPorMoneda.has(key)) {
      totalesPorMoneda.set(key, { simbolo, total: 0, orden: orden++ });
    }
    totalesPorMoneda.get(key).total += a.pagoMonto || 0;
  }

  const items = [...totalesPorMoneda.values()]
    .sort((a, b) => a.orden - b.orden)
    .filter((t) => t.total > 0);

  return (
    <Card
      css={{
        marginTop: "1em",
        backgroundColor: "var(--yellow-50)",
        border: "1px solid var(--yellow-200)"
      }}
    >
      <div css={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <i
          className="pi pi-clock"
          css={{ fontSize: "1.5rem", color: "var(--yellow-600)" }}
        />
        <div>
          <div css={{ fontWeight: "bold", color: "var(--yellow-700)" }}>
            Totales pendiente de pago
          </div>
          <div
            css={{
              color: "var(--yellow-700)",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "0.75em"
            }}
          >
            {items.map((it, i) => (
              <Fragment key={i}>
                {i > 0 && (
                  <span
                    css={{
                      display: "inline-block",
                      width: "1px",
                      height: "1.2em",
                      backgroundColor: "var(--yellow-600)",
                      opacity: 0.4
                    }}
                  />
                )}
                <span>
                  {it.simbolo} {formatMonto(it.total)}
                </span>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
